// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder__CY99F","cards":"cards__CCez1","card":"card__O1kj3","title":"title__XZe3g","titleLink":"titleLink__ztm0Z"};